import { Registry } from '@bem-react/di';
import { ComponentType } from 'react';

import PaginatorButton, { PaginatorButtonProps } from '../__button/paginator__button';
import { cnPaginator } from '../utils';

export interface PaginatorRegistry {
    PaginatorButton: ComponentType<PaginatorButtonProps>;
}

export const paginationRegistry = new Registry({ id: cnPaginator() });

paginationRegistry.set('PaginatorButton', PaginatorButton);
